// extracted by mini-css-extract-plugin
export default {"Container":"jrvFBPGu","NutritionGrid":"LfLEvtbH","Cell":"AE1efsoY","NutritionName":"rTAoO43e","NutritionValue":"pjP0dWJX","NutritionDailyIntake":"ecq2R2UP","GridLine":"uyKDhI8r"};